import { render, staticRenderFns } from "./speechCraft.vue?vue&type=template&id=5ee49b05&scoped=true&"
import script from "./speechCraft.vue?vue&type=script&lang=js&"
export * from "./speechCraft.vue?vue&type=script&lang=js&"
import style0 from "./speechCraft.vue?vue&type=style&index=0&id=5ee49b05&prod&scoped=scoped&lang=css&"
import style1 from "./speechCraft.vue?vue&type=style&index=1&id=5ee49b05&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee49b05",
  null
  
)

export default component.exports